import jsonata from 'jsonata';

/**
 * Provides "JSONata" expressions compilation with memoization. Singleton object.
 */
export class JsonataTransformerClass {
  private static instance: JsonataTransformerClass = null;

  /**
   * Get {@link JsonataTransformerClass} instance. Create it if not exists.
   *
   * @returns Transformer instance
   */
  public static getInstance(): JsonataTransformerClass {
    if (!JsonataTransformerClass.instance) {
      JsonataTransformerClass.instance = new JsonataTransformerClass();
    }
    return JsonataTransformerClass.instance;
  }

  private readonly templatesCache: Map<string, jsonata.Expression>;

  private constructor() {
    this.templatesCache = new Map();
  }

  /**
   * Get 'jsonata' transformer for received expression. Create it if not exists.
   *
   * @param expression Expression text
   *
   * @returns Expression instance
   */
  public getTransformer = (expression: string): jsonata.Expression => {
    if (!this.templatesCache.has(expression)) {
      this.templatesCache.set(expression, jsonata(expression));
    }
    return this.templatesCache.get(expression);
  };
}
